<template>
  <div>
    <MainNavigation />
    <nuxt />
    <BikeAddModal />
    <EditBikeModal />
    <QuickQuoteModal />
    <CongratsModal />
    <Footer />
    <BuildBadge />
  </div>
</template>

<script>
/* eslint-disable no-console */
import MainNavigation from '@/components/MainNavigation'
import BikeAddModal from '@/components/modals/BikeAdd'
import EditBikeModal from '@/components/modals/EditBike'
import QuickQuoteModal from '@/components/modals/QuickQuote'
import Footer from '@/components/common/Footer'
import CongratsModal from '@/components/modals/Congrats'
import BuildBadge from '@/components/common/BuildBadge'

import { buildSeoHead } from '@/helpers/seo'

export default {
  components: {
    BuildBadge,
    MainNavigation,
    BikeAddModal,
    EditBikeModal,
    QuickQuoteModal,
    CongratsModal,
    Footer,
  },
  data() {
    return {}
  },
  head() {
    return {
      // Canonical (and noindex where the route has no search value) for every
      // page using this layout — see helpers/seo.js.
      ...buildSeoHead(this.$route.path),
      style: [
        { cssText: this.$store.getters['theme/theme'], type: 'text/css' },
      ],
    }
  },
  computed: {},
  mounted() {
    this.$store.dispatch('quote/setMtaFlag', false)
  },
}
</script>
